var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upgrade-notification-content"},[_vm._t("title",function(){return [_vm._v("\n    "+_vm._s(_vm.title)+".\n  ")]}),_vm._v(" "),_c('a',{on:{"click":_vm.upgrade}},[_vm._v("Upgrade your account")]),_vm._v("\n  to "+_vm._s(_vm.intent)+".\n")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }